import { useQuery } from "@tanstack/react-query";
import shippingCostsApi from "../../../services/shippingCostsApi";

export const useShippingCostsQuery = () => {
  return useQuery({
    queryKey: ["shipping-costs"],
    queryFn: async () => {
      const res = await shippingCostsApi.getShippingCosts();
      return res.data;
    },
    staleTime: 1000 * 60, // 1 minute
  });
};
